import { connect } from 'react-redux';
import Home from '../components/Home';
import {
  requestCatchNews,
  requestCatchPartnerSpecials,
  requestCatchAnnouncementsConfig,
  requestBrands,
  getBrandContacts
} from '../modules/travelmanagerhome';


const mapDispatchToProps = {
  requestCatchNews,
  requestCatchPartnerSpecials,
  requestCatchAnnouncementsConfig,
  requestBrands,
  getBrandContacts,
};

const mapStateToProps = state => ({
  perms: state.auth.perms,
  catchNews: state.catchAnnouncements.catchNews,
  catchPartnerSpecials: state.catchAnnouncements.catchPartnerSpecials,
  catchAnnouncementsConfig: state.catchAnnouncements.catchAnnouncementsConfig,
  brands : state.catchAnnouncements.brands,
  brandsContacts : state.catchAnnouncements.brandsContacts,
  isFetching: state.catchAnnouncements.isFetching,
  needFetch: state.catchAnnouncements.needFetch
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);


// WEBPACK FOOTER //
// src/routes/home/containers/HomeContainer.js